import genererClient from '@/services/tiers/genererTiers';
import {
  TIERS_SOUS_TYPE_BAILLEUR_CONCESSION,
  TIERS_SOUS_TYPE_BAILLEUR_PRIVE,
  TIERS_SOUS_TYPE_BAILLEUR_PRO, TIERS_TYPE_FOURNISSEUR,
  TIERS_SOUS_TYPE_BAILLEUR_ADMINISTRATION_ET_ASSIMILEE,
} from '@/configuration/tiers/tiersConf';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import store from '@/store/store';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import booleanConverter from '@/services/import/General/booleanConverter';

function fillBailleurWithData(bailleur, data) {
  if (data.typeBailleur === 'Particulier') {
    bailleur.nom = data.nomBailleur;
    bailleur.prenom = data.prenomsBailleur ?? '';
    bailleur.nomCommercial = data.raisonSociale ?? nomPrenomGetter(bailleur);
    const civilites = store.getters['parametres/parametre'](PARAMETRES_KEYS.civilite);
    bailleur.civiliteId = data.civilite ? civilites.find((civilite) => {
      return civilite.libelle.toLowerCase() === data.civilite.toLowerCase();
    }).id : null;
  } else {
    bailleur.nomCommercial = data.raisonSociale;
  }
  bailleur.adressePostale.adresse1 = data.adresseBailleur1 ?? '';
  bailleur.adressePostale.adresse2 = data.adresseBailleur2 ?? '';
  bailleur.adressePostale.adresse3 = data.adresseBailleur3 ?? '';
  bailleur.adressePostale.codePostal = data.codePostalBailleur ?? '';
  bailleur.adressePostale.ville = data.villeBailleur ?? '';
  bailleur.adressePostale.pays = data.paysBailleur ?? '';
  if (data.adresseBailleur1
    || data.adresseBailleur2
    || data.adresseBailleur3
    || data.villeBailleur
    || data.codePostalBailleur
    || data.paysBailleur) {
    let intitule = '';
    if (data.typeBailleur === 'Particulier') {
      if (data.civilite !== null && data.civilite) intitule += ' ' + data.civilite;
      if (bailleur.nom !== null && bailleur.nom) intitule += ' ' + bailleur.nom;
      if (bailleur.prenom !== null && bailleur.prenom) intitule += ' ' + bailleur.prenom;
    }
    bailleur.adressePostale.intitule1 = intitule ? intitule.trim() : bailleur.nomCommercial;
  }
  if (data.adresseBailleur1 && data.adresseFacturaction1) {
    bailleur.adresseFacturationDifferente = true;
  }
  bailleur.adresseFacturation.adresse1 = data.adresseFacturaction1 ?? '';
  bailleur.adresseFacturation.adresse2 = data.adresseFacturaction2 ?? '';
  bailleur.adresseFacturation.adresse3 = data.adresseFacturaction3 ?? '';
  bailleur.adresseFacturation.codePostal = data.codePostalAdresseFacturation ?? '';
  bailleur.adresseFacturation.ville = data.villeAdresseFacturaction ?? '';
  bailleur.adresseFacturation.pays = data.paysAdresseFacturation ?? '';
  if (data.adresseFacturaction1
    || data.adresseFacturaction2
    || data.adresseFacturaction3
    || data.villeAdresseFacturaction
    || data.codePostalAdresseFacturation
    || data.paysAdresseFacturation) {
    let intitule = '';
    if (data.typeBailleur === 'Particulier') {
      if (data.civilite !== null && data.civilite) intitule += ' ' + data.civilite;
      if (bailleur.nom !== null && bailleur.nom) intitule += ' ' + bailleur.nom;
      if (bailleur.prenom !== null && bailleur.prenom) intitule += ' ' + bailleur.prenom;
    }
    bailleur.adresseFacturation.intitule1 = intitule ? intitule.trim() : bailleur.nomCommercial;
  }
  bailleur.societeId = store.getters['societe/societeActiveId'];
  bailleur.email = data.emailBailleur ?? '';
  bailleur.portable = data.portableBailleur ?? '';
  bailleur.telephone = data.telephoneFixeBailleur ?? '';
  bailleur.rib.banque = data.libelleBanque ?? '';
  bailleur.rib.titulaire = data.titulaireCompte ?? '';
  bailleur.rib.iban = data.iban ?? '';
  bailleur.rib.bic = data.bic ?? '';
  bailleur.modeReglementId = data.modeReglement ? store
    .getters['parametres/parametre'](PARAMETRES_KEYS.modeReglement).find((modeReglement) => {
      return modeReglement.libelle.toLowerCase().trim() === data.modeReglement.toLowerCase().trim();
    }).id : null;
  bailleur.compteComptable = data.compteComptable ?? '';
  if (data.paiementBloque) bailleur.blocageReglement = booleanConverter(data.paiementBloque);
  bailleur.motifBlocageId = data.motifBlocagePaiement ? store
    .getters['parametres/parametre'](PARAMETRES_KEYS.motifBlocage).find((motifBlocage) => {
      return motifBlocage.libelle.toLowerCase().trim()
        === data.motifBlocagePaiement.toLowerCase().trim();
    }).id : null;
  bailleur.ordreCheque = data.ordreCheque ?? '';
  bailleur.referenceExterne = data.codeBailleur ?? '';
  bailleur.commentairesInternes = data.commentaire ?? '';
  bailleur.numLigneImportDonne = data.numLigne;

  return bailleur;
}

export default function genererBailleur(ligne) {
  const bailleur = genererClient();
  bailleur.type = TIERS_TYPE_FOURNISSEUR;

  switch (ligne.typeBailleur) {
    case 'Concession':
      bailleur.sousTypes = [TIERS_SOUS_TYPE_BAILLEUR_CONCESSION];
      break;
    case 'Particulier':
      bailleur.sousTypes = [TIERS_SOUS_TYPE_BAILLEUR_PRIVE];
      break;
    case 'Professionnel':
      bailleur.sousTypes = [TIERS_SOUS_TYPE_BAILLEUR_PRO];
      break;
    case 'Administration et assimilée':
      bailleur.sousTypes = [TIERS_SOUS_TYPE_BAILLEUR_ADMINISTRATION_ET_ASSIMILEE];
      break;
    default:
      break;
  }
  return fillBailleurWithData(bailleur, ligne);
}
